import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import FormDataContext from "integrations/contexts/FormDataContext";
import useFetch from "integrations/hooks/useFetch";
import Store from "logic/local-storage/Store";
import { StatusIcon } from "components/common";
import urlWithEventHubParams from "enterprise-integrations/helpers/urlWithEventHubParams";
import { ApiRoutes } from "./Routes";
import { toSymantecEDRInputCreateRequest } from "./formDataAdapter";
import FormWrap from "../common/FormWrap";
const Container = styled.div(
  ({ theme }) => css`
    border: 1px solid ${theme.colors.variant.darkest.default};
    margin: 25px 0;
    padding: 15px;
    border-radius: 4px;
    width: max-content;
  `
);
const Subheader = styled.h3`
  margin: 0 0 10px;
`;
const ReviewItems = styled.ul(
  ({ theme }) => css`
    list-style: none;
    margin: 0 0 25px 10px;
    padding: 0;

    li {
      padding: 5px;

      :nth-of-type(odd) {
        background-color: ${theme.colors.table.row.backgroundStriped};
      }
    }

    strong {
      ::after {
        content: ':';
        margin-right: 5px;
      }
    }
  `
);
const StepReview = ({ onSubmit, externalInputSubmit = false }) => {
  var _a;
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const throttleEnabled = !!((_a = formData.symantecEDRThrottleEnabled) == null ? void 0 : _a.value);
  const [saveInput, setSaveInput] = useFetch(
    null,
    (result) => {
      if (result == null ? void 0 : result.id) {
        Store.sessionSet("setup_wizard_input_id", result.id);
      }
      onSubmit();
    },
    "POST",
    toSymantecEDRInputCreateRequest(formData),
    urlWithEventHubParams
  );
  const formError = saveInput.error ? {
    full_message: saveInput.error,
    nice_message: /* @__PURE__ */ React.createElement("span", null, t("symantecedr.review.save_error"))
  } : null;
  useEffect(() => {
    if (saveInput.error) {
      setSaveInput(null);
    }
  }, [saveInput.error, setSaveInput]);
  const handleSubmit = () => {
    if (externalInputSubmit) {
      onSubmit(formData);
      return;
    }
    setSaveInput(ApiRoutes.INTEGRATIONS.SymantecEDR.SAVE_INPUT);
  };
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: t("common.buttons.save_and_start_input"),
      loading: saveInput.loading,
      error: formError,
      description: t("symantecedr.review.description")
    },
    /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Subheader, null, t("common.steps.input_configuration")), /* @__PURE__ */ React.createElement(ReviewItems, null, /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, t("symantecedr.review.name")), /* @__PURE__ */ React.createElement("span", null, formData.symantecEDRName.value)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, t("symantecedr.review.management_server")), /* @__PURE__ */ React.createElement("span", null, formData.managementIP.value)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, t("symantecedr.review.client_id")), /* @__PURE__ */ React.createElement("span", null, formData.clientId.value)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, t("symantecedr.review.subscribed_to")), /* @__PURE__ */ React.createElement("span", null, formData.content_type.value)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, t("symantecedr.review.enable_throttling")), /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(StatusIcon, { active: throttleEnabled })))))
  );
};
export default StepReview;
